// Renders an AI chat message's markdown (bold, lists, headers, tables) as real formatted HTML
// instead of showing raw "**bold**"/"- item" text. Shared by every AI chat panel in the app
// (Sales & Margin's "Ask AI", Maintenance's Knowledge Assistant) so formatting stays consistent.
import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

export default function MarkdownMessage({ content, style }) {
  return (
    <div className="markdown-message" style={{ fontSize: 14, lineHeight: 1.5, ...style }}>
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        components={{
          p: ({ node, ...props }) => <p className="mb-2" {...props} />,
          ul: ({ node, ...props }) => <ul className="mb-2 ps-3" {...props} />,
          ol: ({ node, ...props }) => <ol className="mb-2 ps-3" {...props} />,
          li: ({ node, ...props }) => <li className="mb-1" {...props} />,
          h1: ({ node, children, ...props }) => <h6 className="fw-bold mt-2 mb-1" {...props}>{children}</h6>,
          h2: ({ node, children, ...props }) => <h6 className="fw-bold mt-2 mb-1" {...props}>{children}</h6>,
          h3: ({ node, children, ...props }) => <h6 className="fw-bold mt-2 mb-1" {...props}>{children}</h6>,
          table: ({ node, children, ...props }) => (
            <div className="table-responsive">
              <table className="table table-sm" {...props}>{children}</table>
            </div>
          ),
          code: ({ node, children, ...props }) => <code style={{ fontSize: 12.5 }} {...props}>{children}</code>,
          a: ({ node, children, ...props }) => <a target="_blank" rel="noreferrer" {...props}>{children}</a>,
        }}
      >
        {content || ''}
      </ReactMarkdown>
    </div>
  );
}
